<!-- 상관 분석 뷰 컴포넌트 -->
<template>
    <div class="scatter-chart-view" style="height: 50rem">
        <div v-if="!isEmpty(sumNodeTrend)" class="col-12" style="height: 45%; margin-bottom: 1.5rem">
            <SumNodeMainTrendPanel
                v-if="!isEmpty(sumNodeTrend.results) && isSumNodeTrend"
                :baseData="sumNodeTrend"
                :dispBaseIdx="currentNode.sysNodeIdx"
                :compData="rltdTrendData"
                :dispCompIdx="selectedRltdPtIdx"
                :queryType="queryType"
                :predictData="predictData"
                :predictTitle="'예측값'"
                :unit="currentNode.sumUnit"
            />
            <div
                v-else
                class="empty-state"
                style="
                    height: 100%;
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                "
            >
                <span class="detail-notification-icon">
                    <i class="fas fa-exclamation-circle"></i>
                </span>
                <span class="detail-notification-text">표시할 데이터가 없습니다.</span>
            </div>
        </div>
        <div class="col-12" style="height: 50%; padding-top: 1.5rem; border-top: 1px solid #ececec">
            <ScatterChartPanel
                v-if="!isEmpty(baseChartData)"
                :rltdTrendData="rltdTrendData"
                :baseChartData="baseChartData"
                :compIdx="selectedRltdPtIdx"
                :regressionResult="regressionResult"
            />
            <div
                v-else
                class="empty-state"
                style="
                    height: 100%;
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                "
            >
                <span class="detail-notification-icon">
                    <i class="fas fa-exclamation-circle"></i>
                </span>
                <span class="detail-notification-text">표시할 데이터가 없습니다.</span>
            </div>
        </div>
    </div>
</template>

<script>
import SumNodeMainTrendPanel from "../../panel/SumNodeMainTrendPanel.vue";
import ScatterChartPanel from "../../panel/ScatterChartPanel.vue";

export default {
    name: "ScatterChartView",
    components: {
        SumNodeMainTrendPanel,
        ScatterChartPanel,
    },
    props: {
        sumNodeTrend: {
            type: Object,
            default: null,
        },
        isSumNodeTrend: {
            type: Boolean,
            default: false,
        },
        currentNode: {
            type: Object,
            required: true,
        },
        rltdTrendData: {
            type: Object,
            default: null,
        },
        selectedRltdPtIdx: {
            type: [Number, String],
            default: null,
        },
        queryType: {
            type: String,
            default: "NOW",
        },
        predictData: {
            type: Array,
            default: () => [],
        },
        baseChartData: {
            type: [Object, Array],
            default: null,
        },
        regressionResult: {
            type: Object,
            default: null,
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../styles/common/_detail-common.scss";

.scatter-chart-view {
    /* 스타일은 필요시 추가 */
}
</style>
